import {Component, OnInit,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DatePipe } from '@angular/common';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DialogData } from 'app/dashboard/remarks/remarks.component';
import { ApptSearchModel } from 'app/opdvisits/Models/ApptSearchModel.model';
import {TranslateService} from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { AuthService } from 'app/auth/auth.service';


@Component({
  selector: 'app-search-appt-dialog',
  templateUrl: './search-appt-dialog.component.html',
  styleUrls: ['./search-appt-dialog.component.scss']
})
export class SearchApptDialogComponent implements OnInit {
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<ApptSearchModel>();
  currentDate=this.authService.getServerDate;
  startdate=this.currentDate;
  enddate =this.currentDate;

  constructor(
    public dialogRef: MatDialogRef<SearchApptDialogComponent>,
    public opdvisitService: OpdVisitService,
    public datepipe: DatePipe,
    public dashboardService: DashboardService,
    public dialog: MatDialog,
    public authService: AuthService,
    public translate: TranslateService,
    public langservice:LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) 
    {
      
     dialogRef.disableClose = true;
     translate.addLangs(['en', 'fr','hi']);
     // translate.setDefaultLang('hi');
     // this.langservice.setlang
     if(this.langservice.setlang){
       translate.setDefaultLang(this.langservice.setlang);
     }
     else{
       translate.setDefaultLang('en');
     }
    
     console.log('current-language', this.langservice.setlang)
    }

   //  displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
   //   'Care_of', 'Old_Mrno', 'Adhar_no', 'Address','Mothername','Email','dob','phno','mobno'];
   //  displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
    // 'dob','phno','mobno'];
    // DarSrNo
    // BookingBranch
    // BookingDate 
    // ApptDate
    // ApptTime
    // PatientId
    // PatientName
    // ContactNo
    // IsCancelled
    // ReferredBy
    // DoctorName

     displayedColumns: string[] = ['pkAppId','branchName', 'bookingDate', 'appDate',
     'appTime','patientId','patientName','contactNo','isCancelled','doctorName','referredBy','appType'];
    
     public branchId?: number;
     public branchName?: string;
     public bookingDate?: string;
     public appDate?: string;
     public appTime?: string;
     public doctorName?: string;
     public patientId?: number;
     public patientName?: string;
     public contactNo?: string;
     public isCancelled?: string;
     public referredBy?: string;
     public appType?: string;
     public appTakenBy?: string;
     public givenBy?: string;
     public modifyBy?: string;


   // displayedColumns: string[] = ['fkBranchId'];
    ngOnInit() {
      //console.log("usertype selected " + this.data.usertype);
      //this.checkusertype (this.data.usertype);
      this.dataSource.data = this.opdvisitService.apptsearch;
     // this.patientcount = this.opdvisitService.apptsearch.length;
      this.get_records_between_two_dates();
    }

    applyFilter(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
     
    }

   


    get_records_between_two_dates(){

      this.showspinner = true;
      this.dataSource.data = [];
     // this.dashboardService.selecteddate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
      let sdate = this.datepipe.transform(this.startdate, "yyyy-MM-dd");
      let edate = this.datepipe.transform(this.enddate, "yyyy-MM-dd");
//alert("st-" +this.startdate);
     this.opdvisitService.get_appt_sdate_edate(sdate,edate).
     subscribe(data => this.success_appt_sdate_edate(data), err => this.failed_appt_sdate_edate(err));
   }
 
   success_appt_sdate_edate(data){
    
   this.showspinner = false;
   this.opdvisitService.apptsearch = [];
   this.opdvisitService.apptsearch = data;
   this.dataSource.data = this.opdvisitService.apptsearch;
  // alert("Crossed");
   console.log(data);

  //this.patientcount = this.opdvisitService.apptsearch.length;
   }
 failed_appt_sdate_edate(err){
  this.showspinner = false;
 }


  onNoClick(): void {
    
    this.dialogRef.close();
   // this.opdvisitService.WinsCount=0;
  }

 
selectpatient(selectedpatient: ApptSearchModel){
   
  this.opdvisitService.getapptdetails(selectedpatient.pkAppId);

 this.opdvisitService.apptdetail = selectedpatient;
 this.dialogRef.close();

}

 
}

